module.exports = __webpack_public_path__ + "static/media/skill_icon.f3358707.png";